export const formatNumber = (value: number) => {
	if (value === 0) {
		return '0';
	}
	//Format abbbccc => a bbb ccc

	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
